import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, Flex, Text, Button } from 'rebass';
import { useWindowSize } from 'react-use';
import { useHasDrawer } from 'app/mobile-drawer/hooks';
import { WatchMeGrowOptions } from 'app/navigation/sidebar/index';
import useLocation from 'app/hooks/location';
import useRouteFromEntityParams from 'collections/hooks/route-from-entity-params';

const Wrapper = ({ children, isOnFreeTrial, onTrialClick }) => {
    const { replace } = useHistory();

    const hasDrawer = useHasDrawer()
    const { width } = useWindowSize();
    const { pathname } = useLocation();
    const { type, id } = useParams()
    const route = useRouteFromEntityParams({ type, id });

    return <>
        <Box m={width < 600 ? 2 : 4} mr={2} mb={hasDrawer && (isOnFreeTrial ? 9 : 5)}>
            {children}
        </Box>
        {hasDrawer && <Box sx={{
            position: 'fixed',
            bottom: 0,
            width: '100vw',
            zIndex: 999
        }}>
            {isOnFreeTrial && <Button
                onClick={onTrialClick}
                p="10px 30px" sx={{
                    borderRadius: 0,
                    width: '100vw', '>svg': {
                        mb: '-3px'
                    }
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.2693 9.53516V9.53668M7.7308 9.53668C7.72702 9.53668 7.7336 9.53668 7.72888 9.53668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10 16.9454C13.1288 16.9439 15.8701 14.8504 16.6953 11.8324C17.6301 11.7306 18.3382 10.9412 18.3382 10.0009C18.3382 9.06053 17.6301 8.2711 16.6953 8.16926C15.8723 5.14967 13.1298 3.05469 10 3.05469C6.87028 3.05469 4.12782 5.14967 3.30475 8.16926C2.36997 8.2711 1.66187 9.06053 1.66187 10.0009C1.66187 10.9412 2.36997 11.7306 3.30475 11.8324C4.12994 14.8504 6.87131 16.9439 10 16.9454Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.8524 12.5087C10.7911 13.4346 9.20894 13.4346 8.14758 12.5087M9.07377 5.99258C9.34286 6.18886 9.66694 6.29534 10 6.29687C10.881 6.27689 11.5848 5.55699 11.5848 4.67578C11.5848 3.79457 10.881 3.07466 10 3.05469" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                &nbsp;
                Unlock Watch Me Grow
            </Button>}
            <Flex
                bg="#fff"
                justifyContent="space-around"
                alignItems="center"
                p="17px 0px"

            >

                {([...WatchMeGrowOptions, {
                    icon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M12.2694 9.53516V9.53668M7.73086 9.53668C7.72708 9.53668 7.73366 9.53668 7.72894 9.53668" stroke="#64748B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0005 16.9454C13.1292 16.9439 15.8706 14.8504 16.6957 11.8324C17.6306 11.7306 18.3387 10.9412 18.3387 10.0009C18.3387 9.06053 17.6306 8.2711 16.6957 8.16926C15.8727 5.14967 13.1302 3.05469 10.0005 3.05469C6.87074 3.05469 4.12828 5.14967 3.30521 8.16926C2.37042 8.2711 1.66232 9.06053 1.66232 10.0009C1.66232 10.9412 2.37042 11.7306 3.30521 11.8324C4.1304 14.8504 6.87177 16.9439 10.0005 16.9454Z" stroke="#64748B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.8527 12.5067C10.7913 13.4326 9.20915 13.4326 8.1478 12.5067M9.07399 5.99063C9.34307 6.18691 9.66715 6.29338 10.0002 6.29492C10.8812 6.27493 11.585 5.55503 11.585 4.67383C11.585 3.79262 10.8812 3.07271 10.0002 3.05273" stroke="#64748B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>, label: "Watch Me Grow"
                }] || []).map(({ icon, label }) => {
                    const isOptionSelected = pathname.split('/').includes(label === 'Book Preview' ? 'collage-preview' : label.toLowerCase().replace(/ /g, '-'));
                    if (isOptionSelected)
                        return null

                    return (
                        <Flex
                            key={label}

                            onClick={() => replace(`${route}/${label === 'Book Preview' ? 'collage-preview' : label.toLowerCase().replace(/ /g, '-')}`)}
                            ml="24px"
                            bg={'white'}
                            sx={{ borderRadius: '100px', cursor: 'pointer' }}
                        >
                            {icon()}
                            <Text ml={1} fontSize="16px" fontFamily="Poppins" fontWeight={500} lineHeight="20px" color="#64748B">
                                {label}
                            </Text>
                        </Flex>
                    );
                })}
            </Flex>
        </Box>}
    </>
};

export default Wrapper;
